import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { UserSessionService } from './usersession.service';
import { AuthenticationService } from './authentication.service';
import { AlertService } from './alert.service';
import { Observable, throwError } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import swal from 'sweetalert2';
import { UserService } from './user.service';
import { LoaderService } from './loader.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()

export class HttpInterceptorService implements HttpInterceptor {

    private baseUrl = environment.apipublicUrl;
    count: number = 0;

    constructor(
        private router: Router,
        private sessionService: UserSessionService,
        private authService: AuthenticationService,
        private loaderService: LoaderService,
        private userService: UserService,
        private toastrService: ToastrService,
        private alertService: AlertService,
        public translate: TranslateService) { }

    // intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //     debugger
    //     this.loaderService.show();
    //     this.count = this.count+1;
    //     const started = Date.now();
    //     // window.location.href = '';
    //     // return

    //     // add authorization header with jwt token if available
    //     const authToken = this.sessionService.authToken();
    //     const isTokenEndPoint = request.url.match('/api/token');
    //     if (isTokenEndPoint === null && this.sessionService.userId() && authToken) {
    //         request = request.clone({
    //             setHeaders: {
    //                 Authorization: `Bearer ${authToken}`,
    //             }
    //         });
    //     }

    //     return next.handle(request).pipe(tap((event: any) => {
    //         if (event instanceof HttpResponse) {
    //             const action = request.urlWithParams.replace(this.baseUrl, '');
    //             const elapsed = Date.now() - started;
    //             this.count = this.count-1;
    //             if(this.count == 0)
    //             {
    //                 this.loaderService.hide();
    //             }
    //         }
    //     }, (error: any) => {
    //         if (error instanceof HttpErrorResponse) {
    //             if (error.status === 401) {
    //                 this.authService.logOut();
    //                 this.router.navigate(['/auth/login']);
    //             } else if (error.status === 403) {
    //                 this.forceLogout();
    //             } else {
    //                 this.broadcastFriendlyErrorMessage(error);
    //             }
    //             this.loaderService.hide();
    //         }
    //         return throwError(error);
    //     })) as any;
    // }
    // intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //     debugger
    //     this.count++;
    //     console.log("REQUEST START →", this.count);
    //     this.loaderService.show();

    //     const started = Date.now();
    //     const authToken = this.sessionService.authToken();
    //     const isTokenEndPoint = request.url.match('/api/token');
    //     if (!isTokenEndPoint && this.sessionService.userId() && authToken) {
    //         request = request.clone({
    //             setHeaders: {
    //                 Authorization: `Bearer ${authToken}`,
    //             },
    //         });
    //     }

    //     return next.handle(request).pipe(
    //         tap({
    //             next: (event) => {
    //                 if (event instanceof HttpResponse) {
    //                     this.handleRequestComplete(request.urlWithParams, started);
    //                 }
    //             },
    //             error: (error) => {
    //                 this.handleRequestComplete();
    //                 this.handleError(error);
    //             },
    //         }),
    //         finalize(() => {
    //             this.count--;
    //               console.log("REQUEST END →", this.count);
    //             if (this.count === 0) {
    //                 this.loaderService.hide();
    //             }
    //         })
    //     );
    // }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.count++;
        this.loaderService.show();

        const started = Date.now(); // 👈 IMPORTANT

        const authToken = this.sessionService.authToken();
        const NO_TOKEN_URLS = [
            '/api/lsg/CheckGrievanceExist',
            '/api/lsg/GenerateOtpLSG',
            '/api/lsg/ValidateOtpLSG',
            '/api/lsg/universitylist',
            '/api/lsg/institute',
            '/api/lsg/streaminfolist',
            '/api/lsg/academicyear',
            '/api/lsg/GetStreamInfoListByInstitute',
            '/api/lsg/courseTypes',
            '/api/lsg/CourseCategory',
            '/api/lsg/course',
            '/api/lsg/CourseBranchWiseModeofStudy',
            '/api/lsg/CourseBranchShiftTimings',
            '/api/lsg/CourseBranchMediumOfInstruction',
            '/api/lsg/CourseBranchName',
            '/api/lsg/statelookup',
            '/api/lsg/districtlookup',
            '/api/lsg/RecordLaptopGrievance',
            '/api/lsg/StudentTempApprovalStatus',
            '/api/lsg/YearOfStudyLookup',
            '/api/lsg/LaptopGrievanceEligible',
            '/api/lsg/ValidateYearOfStudy',
            '/api/lsg/SaveUpdateLaptopGrievance',
            '/api/lsg/GetLaptopGrievance',
            '/api/lsg/GetStudentAuth',
            '/api/lsg/LaptopGrievanceBtnConfig',
            '/api/UMIS/executeSPPaymentFileFreezed'


        ];



        const isNoTokenApi = NO_TOKEN_URLS.some(url =>
            request.url.includes(url)
        );

        if (!isNoTokenApi && authToken) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${authToken}`,
                },
            });
        }

        return next.handle(request).pipe(
            tap({
                next: (event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                        // debugger;
                        this.handleRequestComplete(request.urlWithParams, started);
                    }
                },
                error: (error: HttpErrorResponse) => {
                    this.handleError(error);
                }
            }),
            finalize(() => {
                this.count--;
                if (this.count === 0) {
                    this.loaderService.hide();
                }
            })
        );
    }


    private handleRequestComplete(url?: string, started?: number) {
        if (url && started !== undefined) {
            const action = url.replace(this.baseUrl, '');
            const elapsed = Date.now() - started;
            console.log(`Request for ${action} took ${elapsed} ms.`);
        }
    }

    private handleError(error: HttpErrorResponse) {

        // 🔴 session terminated (logged in elsewhere)
        if (
            error.status === 401 &&
            error.error?.reason === 'SESSION_TERMINATED'
        ) {
            this.forceLogout();
            return;
        }

        // 🔴 normal unauthorized
        if (error.status === 401) {
            this.authService.logOut();
            this.router.navigate(['/auth/login']);
            return;
        }

        // 🟡 forbidden (role / permission)
        if (error.status === 403) {

            this.toastrService.warning(
                'You do not have permission to access this feature.'
            );
            this.forceLogout();
            return; 
        }

        // 🟢 everything else
        this.broadcastFriendlyErrorMessage(error);
    }

    // private handleRequestComplete(url?: string, started?: number) {
    //     if (url && started !== undefined) {
    //         const action = url.replace(this.baseUrl, '');
    //         const elapsed = Date.now() - started;
    //         console.log(`Request for ${action} took ${elapsed} ms.`);
    //     }
    // }

    // private handleError(error: HttpErrorResponse) {
    //     if (error.status === 401) {
    //         this.authService.logOut();
    //         this.router.navigate(['/auth/login']);
    //     } else if (error.status === 403) {
    //         this.forceLogout();
    //     } else {
    //         this.broadcastFriendlyErrorMessage(error);
    //     }
    // }


    broadcastFriendlyErrorMessage(rejection) {
        let msg = '';
        if (rejection.status === 0 && (rejection.statusText === '' || rejection.statusText === 'Unknown Error')) {
            this.alertService.error('Unable to connect to the server, please try again in a couple of seconds.');
        } else if (rejection.status == 423) { //423 - Locked - Check User Permissions
            this.toastrService.warning('Your current user role doesnot have access for this api.');
        } else if (rejection.status == 429) {
            this.alertService.error('You are allowed to send only one OTP every 3 minutes, so try after sometime.');
        } else if (rejection.status === 400) {
            if (rejection.error) {// jshint ignore:line
                msg = (rejection.error.message) ? rejection.error.message : rejection.error; // jshint ignore:line
            }
            this.alertService.error(msg);
        } else if (rejection.status === 404) {
            if (rejection.message) {
                this.alertService.error(rejection.message);
            }
        } else if (rejection.status === 500) {
            if (rejection.error && rejection.error.Message) {
                this.alertService.error(rejection.error.Message);
            } else if (rejection.message) {
                const message = rejection.message;
                this.alertService.error(message);
            }
        } else if (rejection.status === 409) {
            if (rejection.error && rejection.error.Message) {
                this.alertService.error(rejection.error.Message);
            } else if (rejection.message) {
                const message = rejection.message;
                this.alertService.error(message);
            }
        } else if (rejection.responseStatus === 401) {
            this.authService.logOut();
            this.router.navigate(['/login']);
        } else if (rejection.responseStatus === 0) {
            this.alertService.error('Error occured, while uploading file');
        } else if (rejection.responseStatus === 400) {
            if (rejection.response) { // jshint ignore:line
                msg = rejection.response; // jshint ignore:line
            }
            this.alertService.error(msg);
        }
    }

    forceLogout() {
        swal.fire({
            title: 'Logout',
            text: 'Another user logged in to your account',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Ok',
            allowOutsideClick: false,
        }).then((result) => {
            if (result.value) {
                // this.userService.logout(true).subscribe(res => {
                this.authService.logOut();
                this.router.navigate(['/auth/login']);
                // });
            }
        })
    }
}
